// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#contact[data-v-919ca694]{background-color:#f4f7f5}.svg-border-waves .v-image[data-v-919ca694]{position:absolute;bottom:0;left:0;height:3rem;width:100%;overflow:hidden}.qr-code-image[data-v-919ca694]{width:100%}", ""]);
// Exports
module.exports = exports;
